/**
 * MCP の接続の許可の画面（pages/McpAuthorize.tsx）が本体を呼ぶ唯一の場所（2026-09-28 creator/mcp-dashboard-login）。
 *
 * 型の正: docs/teams/creator/tasks/mcp-grants-api.md ③④（Core core/agent-journeys と合意 2026-09-28）。Core の README が入ったらそちらが正
 *   （食い違いはここだけ直す。画面は McpAuthRequestResponse と { redirectUrl } しか見ない）。
 * 認証は kds_（ログイン中のセッション・api() が Authorization で付ける）。kdt_ では呼べない口（本体が断る・Core と合意）。
 * 承認 / 拒否の応答の redirectUrl は、本体が組み立てた MCP の戻り先（MCP のオリジンの決まったパス + code + state）。画面はそこへ移るだけ。
 * 再認証（reauthentication_required）が要ると本体が言ったら、画面が今の再認証のダイアログ（components/Reauth.tsx）で証明を足して送り直す
 * = 本文に proof（{ password } か { reauthToken }）をそのまま混ぜる形（ほかの大事な操作と同じ）。
 */
import { api } from './api';
import type { McpScope } from './mcpAuthorize';

const base = (id: string) => `/v1/developers/mcp-authz-requests/${encodeURIComponent(id)}`;

/**
 * 要求を読む GET のパス（画面は useResource で読む = 読み込み中・エラーの扱いを他の画面とそろえる）。応答は McpAuthRequestResponse
 * （要求・本人のプロジェクト・本人のメールと確認済みか）。404 not_found（無い・期限切れ・使用済み）は画面が「期限切れ」として出す
 */
export const mcpAuthRequestPath = (id: string) => base(id);

export async function approveMcpAuthRequest(
  id: string,
  body: { scopes: McpScope[]; projectIds: string[] | null },
  proof: Record<string, string> = {}
): Promise<{ redirectUrl: string }> {
  return api<{ redirectUrl: string }>(`${base(id)}/approve`, { method: 'POST', body: { ...body, ...proof } });
}

export async function denyMcpAuthRequest(id: string): Promise<{ redirectUrl: string }> {
  return api<{ redirectUrl: string }>(`${base(id)}/deny`, { method: 'POST', body: {} });
}
